<template>
  <b-col xl="2" md="3" sm="4" cols="6" class="mb-4 text-center">
    <b-row>
      <b-col sm="12" class="text-center">
        <div>
          <b-modal v-model="showModal" hide-footer>
            Tem certeza que deseja excluir esse {{templateName}}?
            <b-row>
              <b-col>
                <b-button class="mt-3 bg-danger" block @click="removeTemplate">Sim</b-button>
              </b-col>
              <b-col>
                <b-button class="mt-3 bg-sucess" block @click="showModal = false">Não</b-button>
              </b-col>
            </b-row>
          </b-modal>
        </div>
        <div>
          <b-modal v-model="showModalMine" hide-footer>
            Tem certeza que deseja excluir esse {{templateName}}?
            <b-row>
              <b-col>
                <b-button class="mt-3 bg-danger" block @click="removeTemplateMine">Sim</b-button>
              </b-col>
              <b-col>
                <b-button class="mt-3 bg-sucess" block @click="showModalMine = false">Não</b-button>
              </b-col>
            </b-row>
          </b-modal>
        </div>
        <div id="image" class="text-center" style="width: 100%; text-align: center;">
          <a v-if="!this.isStory" target="_blank" @click="useTemplate()">
            <div class="hovereffect" style="cursor: pointer !important;">
              <img class="img-responsive" v-bind:src="thumbnail" alt style="max-height: 100%;" />
              <div class="overlay">
                <h2></h2>
                <p>Usar Agora</p>
              </div>
            </div>
          </a>

          <a v-if="this.isStory" target="_blank" @click="useTemplate()">
            <div class="hovereffect" style="cursor: pointer !important;">
              <img class="img-responsive" v-bind:src="thumbnail" alt style="max-height: 100%;" />
              <div class="overlayStory">
                <p>Usar Agora</p>
              </div>
            </div>
          </a>
        </div>
      </b-col>
      <b-col sm="12">
        <div v-if="!hideInfo && isMine">
          <div
          style="margin-top: 10px; margin-right: 5px; color: #63c2de">
              <span v-b-tooltip.hover.bottom v-bind:title="'Remover dos Meus ' + templateName + 's'" class="badge badge-pill badge-primary">
              <i
              @click="showModalMine = true"
                class="fa fa-trash text-center favorited"
                aria-hidden="true"
              ></i>
            </span>
          </div>
        </div>
        <div v-else-if="!hideInfo && !isMine">
          <div
          style="margin-top: 10px; margin-right: 5px; color: #63c2de">
            <span v-show="isFavorite" v-b-tooltip.hover.bottom v-bind:title="'Remover dos Favoritos'" class="badge badge-pill badge-primary">
              <i
              @click="showModal = true"
                class="fa fa-trash text-center favorited"
                aria-hidden="true"></i>
            </span>
          </div>
          <span v-show="selected == true && !isFavorite" v-b-tooltip.hover.bottom v-bind:title="'Você favoritou este ' + templateName" class="badge badge-pill badge-primary">
            <i
              class="fa fa-heart text-center favorited"
              aria-hidden="true"
            ></i>
          </span>
          <span v-show="selected == false && !isFavorite" v-b-tooltip.hover.bottom v-bind:title="'Clique para enviar para enviar para os favoritos'" class="badge badge-pill badge-primary">
            <i
              class="fa fa-heart-o text-center"
              v-on:click="addToFavorite"
              aria-hidden="true"
            ></i>
          </span>
          <span v-show="customColorsVersion">
            <img style="max-width: 17px;" src="/img/icone-colorido.png"/>
          </span>
          <span v-show="isVideo" class="badge badge-pill badge-success">
            <i class="fa fa-play"></i>
          </span>
      </div>
      <slot></slot>
      </b-col>
    </b-row>
    <b-row v-if="freeUseAllowed">
      <b-col sm="12" v-if="!isMobileScreen">
        <img v-if="!advancedEdition" src="/img/free.png" style="width: 40px; margin-top: -300px;" />
        <img v-else src="/img/free.png" style="width: 40px; margin-top: -350px;" />
      </b-col>
      <b-col sm="12" v-else>
        <img src="/img/free.png" style="width: 40px; margin-top: -235px;" />
      </b-col>
    </b-row>
    {{JSON.stringify()}}
  </b-col>
</template>

<script>
import service from "./../../service";
import { isMobile } from "mobile-device-detect";

export default {
  name: "DesignBox",
  props: {
    classObj: {
      type: String,
      default: "theme-color w-75 rounded mb-3"
    },
    color: {
      type: String,
      default: "bg-secondary"
    },
    thumbnail: "",
    templateId: "",
    isStory: false,
    advancedEdition: false,
    isMine: false,
    isFavorite: false,
    hideInfo: false,
    hasFamily: false,
    freeUseAllowed: false,
    customColorsVersion: "",
    customUseTemplate: false,
    isVideo: "",
    isCarousel: false,
    isAdmin: false,
    originalCarouselTemplateId: undefined,
    carouselEditionId: undefined,
    selectedColorId: undefined,
    selectedCarouselLine: undefined,
    customColorsCarousel: undefined,
    isTester: false,
    newCarouselScreen: false
    
  },
  data: function() {
    return {
      isMobileScreen: isMobile,
      selected: false,
      showModal: false,
      showModalMine: false
    };
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    }
  },
  methods: {
    addToFavorite: function() {
      this.selected = !this.selected;
      service
        .saveFavoriteTemplate({
          templateId: this.templateId
        })
        .then(
          response => {
            /*
            // Create the event
                  var event = new CustomEvent("update-me", {});

                  // Dispatch/Trigger/Fire the event
                  document.dispatchEvent(event);*/
          }
        ).catch(response => {
          console.log(response);
          if (response && response.message) {
            alert(response.message);
          } else {
            alert("Houve um problema ao Salvar este Sleeker. Procure o suporte.");
          }
        });
    },
    useTemplate: function() {
      if (this.customUseTemplate) {
        this.$emit('selected', true);
      } else if (this.isMine) {
        let route = '/design/preview-mine/' + this.templateId;

    
        if (this.originalCarouselTemplateId && this.carouselEditionId) {
          route = '/design/preview-carousel-mine/' + this.originalCarouselTemplateId + "?carouselEditionId=" + this.carouselEditionId + "&customColorsCarousel=" + ((this.customColorsCarousel && this.customColorsCarousel != "false" && this.customColorsCarousel != false) ? 1 : "") +  "&selectedColorId=" + this.selectedColorId +  "&selectedCarouselLine=" + this.selectedCarouselLine;
        }
        
        this.$router.push(route);
       } else {
         if (this.isMobileScreen) {
           if (this.isCarousel) {//liberar carrossel
            if (this.newCarouselScreen) {
              this.$router.push({ name: 'Preview Carousel2', params: { id: this.templateId }});
            } else {
              this.$router.push({ name: 'Preview Carousel', params: { id: this.templateId }});
            }
           } else {
             this.$router.push({ name: 'Preview Design', params: { id: this.templateId }});
           }
         } else {
           if (this.isCarousel) {//liberar carrossel
            window.open("/design/preview-carousel/" + this.templateId, "_blank")
           } else {
            window.open("/design/preview/" + this.templateId, "_blank")
           }
         }
       }
    },
    removeTemplate: function() {
      service
        .deleteFavoriteTemplate(this.templateId
        )
        .then(
          response => {
            this.showModal = false;
            //TODO: Emitir pra cima para dar refresh
            this.$emit("favoriteDeleted");
          },
          () => {
            this.showError = true;
          }
        );
    },
    removeTemplateMine: function() {
      service
        .deleteTemplateMine(this.templateId
        )
        .then(
          response => {
            this.showModal = false;
            //TODO: Emitir pra cima para dar refresh
            this.$emit("favoriteDeleted");
          },
          () => {
            this.showError = true;
          }
        );
    }
  }
};
</script>

<style scoped>
.hovereffect {
  width: wrap;
  height: wrap;
  float: left;
  overflow: hidden;
  position: relative;
  text-align: center;
  cursor: default;
}

.hovereffect .overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  padding: 50px 20px;
}

.hovereffect .overlayStory {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  padding: 50px 2px;
}

.hovereffect img {
  display: block;
  position: relative;
  max-width: none;
  width: calc(100%);
  backface-visibility: hidden;
}

.hovereffect:hover img {
  opacity: 0.4;
  filter: alpha(opacity=40);
}

.hovereffect h2 {
  text-transform: uppercase;
  color: #fff;
  text-align: center;
  position: relative;
  font-size: 17px;
  overflow: hidden;
  font-weight: bold;
  padding: 0.5em 0;
  background-color: transparent;
}

.hovereffect h2:after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #fff;
  font-weight: bold;
  content: "";
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}

.hovereffect:hover h2:after {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.hovereffect a,
.hovereffect p {
  font-weight: bold;
  font-size: 100%;
  color: #fff;
  opacity: 0;
  filter: alpha(opacity=0);
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.hovereffect:hover a,
.hovereffect:hover p {
  opacity: 1;
  filter: alpha(opacity=100);
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

/*
.favorited {
  color: red;
}
.notFavorited {
  color: black;
}
*/
</style>